import { render } from "./TaskFolderItemModal.vue?vue&type=template&id=21aee5db"
import script from "./TaskFolderItemModal.vue?vue&type=script&lang=js"
export * from "./TaskFolderItemModal.vue?vue&type=script&lang=js"

import "./TaskFolderItemModal.vue?vue&type=style&index=0&id=21aee5db&lang=css"

import exportComponent from "E:\\Sources\\Repos\\TaskApi\\TaskApp.VueCore\\clientTaskApp\\clientTaskApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__